import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'neokaripapaya-language';
const supportedLanguages = ['ru', 'en'];

export const translations = {
  ru: {
    brand: '«Неокарипапайя»',
    brandPlain: 'Неокарипапайя',
    language: 'Язык сайта',
    buy: 'Где купить',
    russia: 'В России',
    cis: 'В СНГ',
    home: 'На главную',
    navigation: 'Основная навигация',
    logoAlt: 'Логотип Неокарипапайя',
    important: 'Важно:',
    disclaimer:
      'информация на сайте носит ознакомительный характер. Перед применением крема или геля проконсультируйтесь со специалистом и изучите инструкцию производителя.',
    instruction: 'Инструкция по применению',
    composition: 'Состав',
    application: 'Применение',
    storage: 'Хранение',
    contraindications: 'Противопоказания',
    shelfLife: 'Срок годности',
    app: {
      bannerAlt: 'Свежая папайя',
      bannerAria: 'Неокарипапайя крем и гель',
      title: 'Что такое «Неокарипапайя»?',
      teaser:
        'Основным активным веществом «Неокарипапайя» является папаин - млечный сок папайи.',
      expand: 'Развернуть',
      collapse: 'Свернуть',
      papainTitle: 'Что такое папаин?',
      papain:
        'Папаин - растительная протеаза (протеолитический фермент), усиливающая расщепление белков, пептидных молекул, углеводов, жиров.',
      keyProperties: 'Ключевые свойства:',
      properties: [
        'способен расщеплять белки, в т. ч. коллаген и денатурированные белки;',
        'сохраняет активность при правильном хранении в составе препаратов.',
      ],
      effectTitle: 'Как папаин усиливает терапевтический эффект?',
      effectIntro: 'В составе крема и геля папаин:',
      effects: [
        'Расщепляет омертвевшие и поврежденные ткани в зоне воспаления или травмы. Это создает условия для регенерации здоровых клеток.',
        'Уменьшает отек и воспаление за счет расщепления белков, поддерживающих воспалительный процесс.',
        'Способствует восстановлению хрящевой ткани и межпозвоночных дисков: размягчает участки дегенерации; помогает освободить зажатые нервы и сосуды - это снижает боль.',
      ],
      usesTitle: 'Применение:',
      uses: [
        'снятие боли в позвоночнике и суставах;',
        'уменьшение воспаления;',
        'содействие регенерации межпозвонковых дисков и хрящевой ткани;',
        'улучшение микроциркуляции в тканях;',
        'масло мяты оказывает успокаивающее, спазмолитическое и анальгетическое действие.',
      ],
      nuancesTitle: 'Важные нюансы!',
      nuances: [
        'Не заменяет основное лечение. Папаинсодержащие средства дополняют медикаментозную терапию и физиопроцедуры, но не являются самостоятельным методом лечения серьезных заболеваний.',
        'Требует консультации врача. Перед применением нужно исключить противопоказания: индивидуальную непереносимость; острые воспаления; некроз тканей, секвестрацию грыжи и др.',
      ],
      productsTitle: 'Крем и гель «Неокарипапайя»',
      productCardAria: 'Карточка товара',
      cream: 'Крем «Неокарипапайя»',
      gel: 'Гель «Неокарипапайя»',
      creamAlt: 'Неокарипапайя крем',
      gelAlt: 'Неокарипапайя гель',
      more: 'Подробнее',
    },
    cream: {
      title: '«Неокарипапайя» крем',
      subtitle: 'туба 50 мл',
      intro:
        '«Неокарипапайя» крем изготовлен на основе ферментов, содержащихся в млечном соке папайи (дынного дерева). Рекомендуется для проведения процедур массажа, самомассажа и фонофореза. Крем «Неокарипапайя» улучшает состояние кожи, способствует регенерации межпозвонковых дисков и хрящевой ткани, улучшает упругость тела и состояние кожи. Крем имеет сбалансированный состав активных действующих веществ, что делает его применение эффективным. Крем «Неокарипапайя» может применяться при массаже, самомассаже и фонофорезе в области пораженных межпозвонковыми грыжами сегментов позвоночника.',
      composition:
        'Вода питьевая, Папаин (экстракт папайи), Глицерин, Цетеариловый спирт, Глицерилстеарат и ПЭГ-100 стеарат, Цетеарилоктаноат, Октилдодеканол, Масло оливы, Масло ореха макадамии, Экстракт центеллы азиатской, Триэтаноламин, Карбопол, Феноксиэтанол, Парфюмерная композиция, Ментол, Метилизотиазолинон.',
      application:
        'Небольшое количество крема нанести в области позвоночника и суставов на кожу тела массирующими движениями до полного впитывания. Применяют один-два раза в день. Длительность применения от 20 до 30 дней. При необходимости делают повторные курсы. Перерыв между повторным применением составляет не менее 30 дней.',
      storage: 'В сухом защищенном от света месте при температуре от +5° до +25° С.',
      contraindications: 'Индивидуальная непереносимость компонентов крема.',
      shelfLife: '24 месяца. Дата изготовления (серия) указана на шве тубы.',
    },
    gel: {
      title: '«Неокарипапайя» гель',
      subtitle: 'туба 50 мл',
      intro:
        'В состав геля «Неокарипапайя» входит экстракт папайи, богатый витаминами А и С, смягчает и успокаивает кожу. Рекомендуется для проведения процедур массажа, самомассажа и фонофореза. Гель «Неокарипапайя» может применяться при массаже, самомассаже и фонофорезе в области пораженных межпозвонковыми грыжами сегментов позвоночника.',
      composition:
        'Вода питьевая, Папаин (экстракт папайи), Глицерин, Аммоний акрилоилдиметилтаурат / винил пирролидона сополимер, Масло оливы, Феноксиэтанол, Парфюмерная композиция, Эфирное масло мяты, Кислота лимонная, Метилизотиазолинон.',
      application:
        'Нанести гель легкими массажными движениями на чистую сухую кожу тела. В случае попадания в глаза немедленно обильно промыть водой. При необходимости обратиться к врачу. Для наружного применения.',
      storage: 'В сухом защищенном от света месте при температуре от +5° до +25° С.',
      contraindications: 'Возможна индивидуальная непереносимость компонентов, входящих в состав геля.',
      shelfLife: '24 месяца. Дата изготовления (серия) указана на шве тубы.',
    },
    order: {
      cisRegion: 'СНГ',
      cisTitle: 'Заказать «Неокарипапайя» в СНГ',
      cisIntro:
        'Для заказа из стран СНГ свяжитесь с дистрибьютором по телефону. Менеджер уточнит условия доставки и оформления заказа.',
      distributor: 'Дистрибьютор',
      cisCompany: 'ОсОО «Постерия»',
      cisCompanyNote: 'Для заказа в Республике Кыргызстан.',
      russiaRegion: 'Россия',
      russiaTitle: 'Заказать «Неокарипапайя»',
      russiaIntro:
        'Для покупки крема и геля «Неокарипапайя» используйте удобный способ связи. Менеджер ответит на вопросы по товару и оформлению заказа.',
      seller: 'Продавец',
      sellerCompany: 'ООО «ПапайяЭкоМед»',
      dagestan: 'Дагестан',
      pharmacy: 'Аптека в Дербенте',
      pharmacyNote: 'Для заказа в Дагестане свяжитесь с аптекой по телефону.',
    },
    contacts: {
      phone: 'Телефон',
      responseTime: 'Время ответа',
      responseValue: 'Ежедневно с 09:00 до 21:00',
      pharmacy: 'Аптека',
      pharmacyName: 'ИП Магомедова Ш.А.',
      address: 'Адрес',
      dagestanAddress: 'г. Дербент, пр. Агасиева 17 "А"',
      company: 'Компания',
      cisCompany: 'ОсОО «Постерия»',
      cisAddress: 'Кыргызская Республика, г. Бишкек, 12 мкр, 57/3',
    },
    seo: {
      '/': ['Неокарипапайя — крем и гель', 'Крем и гель Неокарипапайя: описание товара, контакты продавца, телефон и email для заказа.'],
      '/cream': ['Крем «Неокарипапайя» — инструкция', 'Состав, применение, хранение и противопоказания крема «Неокарипапайя».'],
      '/gel': ['Гель «Неокарипапайя» — инструкция', 'Состав, применение, хранение и противопоказания геля «Неокарипапайя».'],
      '/buy/russia': ['Купить «Неокарипапайя» в России', 'Контакты продавцов крема и геля «Неокарипапайя» в России.'],
      '/buy/cis': ['Купить «Неокарипапайя» в СНГ', 'Контакты дистрибьютора «Неокарипапайя» в странах СНГ.'],
    },
  },
  en: {
    brand: 'Neokaripapaya',
    brandPlain: 'Neokaripapaya',
    language: 'Site language',
    buy: 'Where to buy',
    russia: 'In Russia',
    cis: 'In the CIS',
    home: 'Back to home',
    navigation: 'Main navigation',
    logoAlt: 'Neokaripapaya logo',
    important: 'Important:',
    disclaimer:
      'the information on this website is for reference only. Consult a healthcare professional and read the manufacturer’s instructions before using the cream or gel.',
    instruction: 'Instructions for use',
    composition: 'Ingredients',
    application: 'Directions',
    storage: 'Storage',
    contraindications: 'Contraindications',
    shelfLife: 'Shelf life',
    app: {
      bannerAlt: 'Fresh papaya',
      bannerAria: 'Neokaripapaya cream and gel',
      title: 'What is Neokaripapaya?',
      teaser: 'The main active ingredient in Neokaripapaya is papain, the milky sap of papaya.',
      expand: 'Read more',
      collapse: 'Collapse',
      papainTitle: 'What is papain?',
      papain:
        'Papain is a plant protease (proteolytic enzyme) that promotes the breakdown of proteins, peptide molecules, carbohydrates, and fats.',
      keyProperties: 'Key properties:',
      properties: [
        'breaks down proteins, including collagen and denatured proteins;',
        'remains active when stored correctly as part of the product.',
      ],
      effectTitle: 'How does papain support the therapeutic effect?',
      effectIntro: 'In the cream and gel, papain:',
      effects: [
        'Breaks down dead and damaged tissue in areas of inflammation or injury, helping create conditions for healthy cell regeneration.',
        'Helps reduce swelling and inflammation by breaking down proteins involved in the inflammatory process.',
        'Supports cartilage and intervertebral disc recovery by softening degenerative areas and helping relieve compressed nerves and blood vessels.',
      ],
      usesTitle: 'Uses:',
      uses: [
        'relief of back and joint discomfort;',
        'reduction of inflammation;',
        'support for intervertebral disc and cartilage regeneration;',
        'improved tissue microcirculation;',
        'peppermint oil provides a soothing, antispasmodic, and analgesic effect.',
      ],
      nuancesTitle: 'Please note',
      nuances: [
        'This product does not replace primary treatment. Papain products may complement medication and physiotherapy but are not a standalone treatment for serious conditions.',
        'Medical advice is required. Before use, rule out contraindications such as individual intolerance, acute inflammation, tissue necrosis, or a sequestered hernia.',
      ],
      productsTitle: 'Neokaripapaya cream and gel',
      productCardAria: 'Product card',
      cream: 'Neokaripapaya cream',
      gel: 'Neokaripapaya gel',
      creamAlt: 'Neokaripapaya cream',
      gelAlt: 'Neokaripapaya gel',
      more: 'Learn more',
    },
    cream: {
      title: 'Neokaripapaya cream',
      subtitle: '50 ml tube',
      intro:
        'Neokaripapaya cream is made with enzymes found in the milky sap of papaya. It is recommended for massage, self-massage, and phonophoresis. The cream supports skin condition, intervertebral disc and cartilage regeneration, and skin elasticity. Its balanced combination of active ingredients makes it suitable for use on areas of the spine affected by intervertebral disc problems.',
      composition:
        'Drinking water, papain (papaya extract), glycerin, cetearyl alcohol, glyceryl stearate and PEG-100 stearate, cetearyl octanoate, octyldodecanol, olive oil, macadamia nut oil, Centella asiatica extract, triethanolamine, carbomer, phenoxyethanol, fragrance, menthol, methylisothiazolinone.',
      application:
        'Apply a small amount of cream to the skin around the spine and joints and massage until fully absorbed. Use once or twice daily for 20–30 days. Courses may be repeated when needed, with a break of at least 30 days.',
      storage: 'Store in a dry place protected from light at +5°C to +25°C.',
      contraindications: 'Individual intolerance to any ingredient in the cream.',
      shelfLife: '24 months. The production date and batch are printed on the tube seal.',
    },
    gel: {
      title: 'Neokaripapaya gel',
      subtitle: '50 ml tube',
      intro:
        'Neokaripapaya gel contains papaya extract rich in vitamins A and C to soften and soothe the skin. It is recommended for massage, self-massage, and phonophoresis and may be applied around spinal areas affected by intervertebral disc problems.',
      composition:
        'Drinking water, papain (papaya extract), glycerin, ammonium acryloyldimethyltaurate / VP copolymer, olive oil, phenoxyethanol, fragrance, peppermint essential oil, citric acid, methylisothiazolinone.',
      application:
        'Apply the gel to clean, dry skin with light massage movements. If it gets into the eyes, rinse immediately with plenty of water and seek medical advice if necessary. For external use only.',
      storage: 'Store in a dry place protected from light at +5°C to +25°C.',
      contraindications: 'Individual intolerance to any ingredient in the gel is possible.',
      shelfLife: '24 months. The production date and batch are printed on the tube seal.',
    },
    order: {
      cisRegion: 'CIS',
      cisTitle: 'Order Neokaripapaya in the CIS',
      cisIntro:
        'To order from a CIS country, contact the distributor by phone. A manager will explain delivery and ordering terms.',
      distributor: 'Distributor',
      cisCompany: 'Posteria LLC',
      cisCompanyNote: 'For orders in the Kyrgyz Republic.',
      russiaRegion: 'Russia',
      russiaTitle: 'Order Neokaripapaya',
      russiaIntro:
        'Use the most convenient contact method to purchase Neokaripapaya cream and gel. A manager will answer product and ordering questions.',
      seller: 'Seller',
      sellerCompany: 'PapayaEcoMed LLC',
      dagestan: 'Dagestan',
      pharmacy: 'Pharmacy in Derbent',
      pharmacyNote: 'To order in Dagestan, contact the pharmacy by phone.',
    },
    contacts: {
      phone: 'Phone',
      responseTime: 'Response hours',
      responseValue: 'Daily, 9:00 AM–9:00 PM',
      pharmacy: 'Pharmacy',
      pharmacyName: 'S. A. Magomedova, sole proprietor',
      address: 'Address',
      dagestanAddress: '17A Agasiyev Avenue, Derbent',
      company: 'Company',
      cisCompany: 'Posteria LLC',
      cisAddress: '57/3, Microdistrict 12, Bishkek, Kyrgyz Republic',
    },
    seo: {
      '/': ['Neokaripapaya — cream and gel', 'Neokaripapaya cream and gel: product information and seller contact details.'],
      '/cream': ['Neokaripapaya cream — instructions', 'Ingredients, directions, storage, and contraindications for Neokaripapaya cream.'],
      '/gel': ['Neokaripapaya gel — instructions', 'Ingredients, directions, storage, and contraindications for Neokaripapaya gel.'],
      '/buy/russia': ['Buy Neokaripapaya in Russia', 'Seller contacts for Neokaripapaya cream and gel in Russia.'],
      '/buy/cis': ['Buy Neokaripapaya in the CIS', 'Distributor contacts for Neokaripapaya products in the CIS.'],
    },
  },
};

const LanguageContext = createContext(null);

const initialLanguage = () => {
  const fromUrl = new URLSearchParams(window.location.search).get('lang');
  if (supportedLanguages.includes(fromUrl)) return fromUrl;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return supportedLanguages.includes(stored) ? stored : 'ru';
};

export const localizedHref = (path, language) => {
  const [pathname, hash = ''] = path.split('#');
  return `${pathname}?lang=${language}${hash ? `#${hash}` : ''}`;
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(initialLanguage);

  const setLanguage = useCallback((nextLanguage) => {
    if (supportedLanguages.includes(nextLanguage)) setLanguageState(nextLanguage);
  }, []);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
    const url = new URL(window.location.href);
    url.searchParams.set('lang', language);
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      messages: translations[language],
      href: (path) => localizedHref(path, language),
    }),
    [language, setLanguage],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => {
  const value = useContext(LanguageContext);
  if (!value) throw new Error('useLanguage must be used inside LanguageProvider');
  return value;
};
